import { render, staticRenderFns } from "./Aktivitaeten.vue?vue&type=template&id=984d1abe&"
import script from "./Aktivitaeten.vue?vue&type=script&lang=js&"
export * from "./Aktivitaeten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports